import React from "react";
import ClaroParagraph from "../../atoms/ClaroParagraph";
import ClaroPadding from "../../atoms/ClaroPadding";

const ClaroImage = ({
  src,
  alt,
  height,
  width,
  base64,
  isClaroPartner,
  srcImgClaroSocio,
  isLogoHeaderClaroSocio,
  widthClaroSocio,
  title,
}) => {
  let imgData = base64 ? base64 : src;

  let widthImg = isClaroPartner ? widthClaroSocio : width;

  let margin = "";
  let padding = "0% 0%";
  if (!isLogoHeaderClaroSocio) {
    imgData = isClaroPartner ? srcImgClaroSocio : imgData;
    margin = isClaroPartner ? "0px auto" : "4% auto";
  } else {
    margin = isClaroPartner ? "0px auto" : "2px auto";
    padding = isClaroPartner ? "3% 0% " : "0% 0%";
  }

  return (
    <>
      {title == "AGUA DE MTY" || title == "INTERAPAS" ? (
        imgData ? (
          <img
            style={{ display: "block", margin: margin, padding: padding }}
            src={imgData}
            alt={alt}
            height={height}
            width={"auto"}
          />
        ) : (
          <></>
        )
      ) : imgData ? (
        <img
          style={{ display: "block", margin: margin, padding: padding }}
          src={imgData}
          alt={alt}
          height={height}
          width={widthImg}
        />
      ) : (
        <></>
      )}
    </>
  );
};

ClaroImage.propTypes = {};

export default ClaroImage;
